export default class RetailForm {

    constructor() {
        this.addEvents();
    }

    addEvents() {

        let nova55 = document.querySelector('#input_14_3');
        let novaFlip = document.querySelector('#input_15_3');
        let nova55Value = 0;
        let novaFlipValue = 0;
        let result = document.querySelector('.product-revenue-result span');



        if(nova55 && novaFlip) {

            document.querySelector('#gform_submit_button_14').setAttribute("disabled", "");
            document.querySelector('#gform_submit_button_15').setAttribute("disabled", "");

            
            nova55.addEventListener('input', function (e) {
                e.preventDefault();
                nova55Value = parseInt(this.value) || 0;
                updateResult();
            });

            nova55.addEventListener('change', function (e) {
                e.preventDefault();
                nova55Value = parseInt(this.value) || 0;
                updateResult();
            });

            novaFlip.addEventListener('input', function (e) {
                e.preventDefault();
                novaFlipValue = parseInt(this.value) || 0;
                updateResult();
            });

            novaFlip.addEventListener('change', function (e) {
                e.preventDefault();
                novaFlipValue = parseInt(this.value) || 0;
                updateResult();
            });

        }

        function updateResult() {
            if (novaFlipValue + nova55Value >= 50) {
                result.innerHTML = calc(nova55Value, novaFlipValue);
            } else {
                result.innerHTML = 0;
            }
        }

        function calc(nova, flip) {
            return (169 * nova) + (flip * 269);
        }


    }





}
